import Vue from "vue";
import Vuex from "vuex";

import { sections } from "./sections";
import { info } from "./info";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    info: info,
    sections: sections
  }
});
